<template>
    <div>
        <nav class="navbar navbar-expand-lg navbar-light">
            <div class="ml-auto">
                <form class="form-inline my-2 my-lg-0 col-form-label">
                    <label class="col-form-label">เลือกช่วงวัน</label>
                    &nbsp; &nbsp;
                    <date-picker
                            v-model="search.start_date"
                            type="date"
                            :format="changeFormat"
                            :lang="lang"
                            :not-after="currentDate"
                            placeholder="วันที่เริ่มต้น" >
                    </date-picker> &nbsp;
                    &nbsp;
                    <date-picker
                            v-model="search.end_date"
                            type="date"
                            :format="changeFormat"
                            :lang="lang"
                            :not-after="currentDate"
                            :not-before="search.start_date"
                            placeholder="วันที่สิ้นสุด" >
                    </date-picker>
                    &nbsp;
                    &nbsp;
                    <label class="col-form-label">เลือกเซลล์</label>
                    &nbsp;&nbsp;
                    <div >
                        <multiselect
                                v-model="search.sellers_name"
                                :options="OptionSeller"
                                :customLabel="customLabel"
                                :multiple="true"
                                select-label=""
                                selectedLabel=""
                                deselectLabel=""
                                :close-on-select="false"
                                :clear-on-select="false"
                                :show-labels="false"
                                track-by="id"
                                placeholder="เลือกเซลล์">
                        </multiselect>
                    </div>
                    &nbsp; &nbsp;
                    <label class="col-form-label">เลือกหมวดหมู่สินค้า</label>
                    &nbsp;&nbsp;
                    <div>
                        <multiselect
                                v-model="search.products_type"
                                :options="optionProductType"
                                :customLabel="customLabelType"
                                :show-labels="false"
                                select-label=""
                                selectedLabel=""
                                deselectLabel=""
                                track-by="id"
                                placeholder="เลือกหมวดหมู่สินค้า">
                        </multiselect>
                    </div>
                    &nbsp; &nbsp;
<!--                    <label class="col-form-label">เลือกรหัสสินค้า</label>-->
<!--                    &nbsp;&nbsp;-->
                    <!--                    v-model="search.topics"-->
<!--                    <div>-->
<!--                        <multiselect-->
<!--                                v-model="search.products"-->
<!--                                :options="optionProduct"-->
<!--                                :customLabel="customLabelProduct"-->
<!--                                :multiple="true"-->
<!--                                select-label=""-->
<!--                                selectedLabel=""-->
<!--                                deselectLabel=""-->
<!--                                :close-on-select="false"-->
<!--                                :clear-on-select="false"-->
<!--                                track-by="id"-->
<!--                                placeholder="เลือกรหัสสินค้า">-->
<!--                        </multiselect>-->
<!--                    </div>-->
                    &nbsp; &nbsp;
                    <button class="btn btn-success my-2 my-sm-0"
                            type="button" @click="searchData">
                        <icon name="search"></icon> ค้นหา
                    </button>
                    &nbsp;&nbsp;
                    <button class="btn btn-primary my-2 my-sm-0" type="button">
                        <icon name="download"></icon> Export
                    </button>&nbsp;

                </form>
            </div>
        </nav>

        <div class="table-responsive">
            <table class="table table-bordered text-center">
                <thead >
                    <tr  >
                        <th rowspan="2">
                            รายการสินค้า
                        </th>
                        <template v-for="(sale,key,index) in sale_group_product.sales">
                            <th colspan="3">
                                {{sale.name}}
                            </th>
                        </template>
                    </tr>
                    <tr >
                        <template v-for="item in sale_group_product.sales">
                            <th>หักคืนสินค้า</th>
                            <th>จำนวนสินค้า</th>
                            <th>ยอดขาย</th>
                        </template>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(data,key,index) in sale_group_product.data">
                        <td>{{key}}</td>
                        <template v-for="item in data">
                            <td>{{item.sale_return | currency}}</td>
                            <td>{{item.quantity | currency}}</td>
                            <td>{{item.total | currency}}</td>
                        </template>
                    </tr>
                </tbody>
            </table>
        </div>
        <b-modal hide-footer hide-header ref="loading">
            <loading @submit="hideLoadingModal" :msg="msg" :status="status_loading"></loading>
        </b-modal>
        <br>
<!--        <pre class="alert alert-danger">{{sale_group_product}}</pre>-->
    </div>
</template>

<script>
    import {mapState} from "vuex";
    import Multiselect from "vue-multiselect";
    import DatePicker from 'vue2-datepicker'
    import moment from "moment";
    import Loading from "../../Utility/Loading";

    export default {
        name: "report-product",
        components: {
            Loading,
            Multiselect,
            DatePicker
        },

        created(){
            this.$store.dispatch("Dashboard/clearSearch");
            this.$store.dispatch("Seller/get");
            this.$store.dispatch("ProductType/get");
            this.getCurrentDate();
            this.getSaleProductTable();
        },
        data() {
            return {
                msg : "",
                status_loading : 1,
                currentDate: "",
                products_type_array:[],
                sellers_array:[],
                sale_group_product : [],
                changeFormat: {
                    stringify: (date) => {
                        let date_moment = moment(date).format('YYYY');
                        const year = parseInt(date_moment) + 543;
                        console.log(moment(date).format('DD/MM/'+year));
                        return date ? moment(date).format('DD/MM/'+year) : null
                    },
                    parse: (value) => {
                        return value ? moment(value, 'DD/MM/YYYY').subtract(543, 'y').toDate() : null
                    }
                },
                lang: {
                    days: ['อา', 'จ', 'อ', 'พ', 'พฤ', 'ศ', 'ส'],
                    months: ['มกราคม', 'กุมภาพันธ์', 'มีนาคม', 'เมษายน', 'พฤษภาคม', 'มิถุนายน', 'กรกฎาคม', 'สิงหาคม', 'กันยายน', 'ตุลาคม', 'พฤศจิกายน', 'ธันวาคม'],
                    pickers: ['ถัดไป 7 วัน', 'ถัดไป 30 วัน', 'ก่อนหน้า 7 วัน', 'ก่อนหน้า 30 วัน'],
                    placeholder: {
                        date: 'วว/ดด/ปปปป',
                    }
                },
            };
        },
        computed: {
            ...mapState({
                OptionSeller: state => {
                    return state.Seller.data;
                },
                optionProductType : state =>{
                    return state.ProductType.data;
                },
                optionProduct: state => {
                    return state.Products.product_all;
                },
                search:state =>{
                    return state.Dashboard.search_product;
                },
            }),
        },
        methods:{
            showLoadingModal(){
                this.$refs.loading.show();
            },
            hideLoadingModal(){
                this.$refs.loading.hide();
            },
            getCurrentDate(){
                this.currentDate = moment().format("YYYY-MM-DD");
            },
            customLabel (option) {
                return `${option.sale_id} - ${option.name}`
            },
            customLabelType (option) {
                return `${option.type_code} - ${option.name}`
            },
            customLabelProduct(option) {
                return `${option.sku}`
            },
            getSaleProductTable(){
                this.sale_group_product = [];
                let start_date = moment().startOf('month').format('YYYY-MM-DD');
                let end_date = moment().endOf('month').format('YYYY-MM-DD');
                let product_type = 1;
                let sellers_name = 34;
                let data = {
                  start_date,
                  end_date,
                  product_type,
                  sellers_name
                };
                this.$store.dispatch("Dashboard/getSaleByProduct",data).then(res=>{
                    this.sale_group_product = res;
                });
            },
            searchData(){
                if(!this.search.start_date){
                    alert('กรุณาเลือกวันที่ เริ่มต้น');
                }else if(!this.search.end_date){
                    alert('กรุณาเลือกวันที่ สิ้นสุด');
                }else if(this.search.sellers_name.length < 1){
                    alert('กรุณาเลือกเซลล์');
                }else if(!this.search.products_type){
                    alert('กรุณาเลือกประเภทสินค้า');
                }else{
                    let sellers_name = [];
                    this.search.sellers_name.forEach(seller=>{
                        sellers_name.push(seller.id);
                    })
                    this.msg = "กำลังดาวโหลดข้อมูล กรุณารอสักครู่";
                    this.status_loading = 1;
                    this.showLoadingModal();
                    let data = {
                        start_date : moment(this.search.start_date).format("YYYY-MM-DD"),
                        end_date : moment(this.search.start_date).format("YYYY-MM-DD"),
                        product_type : this.search.products_type.id,
                        sellers_name : sellers_name.toString(),
                    };
                    this.$store.dispatch("Dashboard/getSaleByProduct",data).then(res=>{
                        this.sale_group_product = res;
                        this.hideLoadingModal();
                    }).catch(()=>{
                        this.msg = "ดาวโหลดข้อมูลไม่สำเร็จ";
                        this.status_loading = 3;
                        this.showLoadingModal();
                    })
                }

            },
        }
    }
</script>

<style scoped>

</style>
